module.exports = __webpack_public_path__ + "img/subheader-pc.f4381fef.jpg";